import React, { useState } from "react";
import apiClient from "../lib/apiClient";
type Params = {
  factoryIds: Number[];
  productNo: string;
  salesNo: string;
  situations: Number[];
  dateField: string;
  fromDate: string;
  toDate: string;
  headerOnly: boolean;
  viewId: Number;
  productItems: Number | null;
};
export const useFetchProcesses = () => {
  const [error, setError] = useState<string | null>(null);
  const getProcessForFactory = async (params: Params) => {
    return await executeAPI("/process/getInputProcessForFactory/?", params);
  };
  const getProcessForSite = async (params: Params) => {
    return await executeAPI("/process/getProcessForSite/?", params);
  };
  const executeAPI = async (url: string, params: Params) => {
    console.log("params", params);
    const {
      factoryIds,
      productNo,
      salesNo,
      situations,
      dateField,
      fromDate,
      toDate,
      headerOnly,
      viewId,
      productItems,
    } = params;
    setError(null);
    // const newParams = {...params};
    let strHeaderOnly = "false";
    if (headerOnly === true) {
      strHeaderOnly = "true";
    }
    const newParams = {
      factoryIds: factoryIds.length > 0 ? factoryIds.join(",") : "",
      productNo,
      salesNo,
      situations: situations.length > 0 ? situations.join(",") : "",
      dateField,
      fromDate,
      toDate,
      headerOnly: strHeaderOnly,
      viewId: String(viewId),
      productItems: "",
    };
    console.log(newParams);
    const queryParams = new URLSearchParams(newParams).toString();

    try {
      const startTime = Date.now(); // リクエスト前の時刻を記録
      const res = await apiClient.get(
        `${url}${queryParams}`
        // `/process/getProcessForSite/?${queryParams}`
      );
      const endTime = Date.now(); // リクエスト後の時刻を記録
      const duration = endTime - startTime; // ミリ秒単位での時間差を計算
      console.log(`APIのフェッチ時間: ${duration}ms`);
      console.trace("res.data", res.data);
      // console.log(res.data);
      return res.data;
      console.log("res.data", res.data);
    } catch (error) {
      setError("エラー:取得に失敗しました: " + error);
      throw new Error("エラー:取得に失敗しました: " + error);
    }
  };
  return { error, getProcessForFactory, getProcessForSite };
};
